module.exports = __webpack_public_path__ + "lato-normal-italic-f28f2d6482446544ef1ea1ccc6dd5892.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lato-normal-italic/lato-normal-italic.woff
// module id = 1049
// module chunks = 0